import type { Editor } from '@tiptap/react';

/** True when the selection sits inside a table cell. */
export function isInTable(editor: Editor): boolean {
  return editor.isActive('table');
}

/**
 * Table handle actions — thin wrappers over TableKit's built-in commands, kept
 * separate from the React component so the behavior is unit-testable without
 * mounting UI. Each focuses the editor and runs the command.
 */
export const TABLE_ACTIONS = {
  insertRowAbove: (editor: Editor) => editor.chain().focus().addRowBefore().run(),
  insertRowBelow: (editor: Editor) => editor.chain().focus().addRowAfter().run(),
  deleteRow: (editor: Editor) => editor.chain().focus().deleteRow().run(),
  insertColumnLeft: (editor: Editor) => editor.chain().focus().addColumnBefore().run(),
  insertColumnRight: (editor: Editor) => editor.chain().focus().addColumnAfter().run(),
  deleteColumn: (editor: Editor) => editor.chain().focus().deleteColumn().run(),
  deleteTable: (editor: Editor) => editor.chain().focus().deleteTable().run(),
} as const;
